import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'fr_FR',
    debug: false, // For development mode
    resources: {},
    keySeparator: '.', // to have multiple level of translations

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;